import React from "react";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";
import * as resolutionProposalActionTypes from './commentResolutionProposalActionTypes';

class CommentForm extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {       
        const { nextAction, onSubmit, onChange, value } = this.props;
        let isRequired = (nextAction === resolutionProposalActionTypes.REQUEST_FOR_INFORMATION || nextAction === resolutionProposalActionTypes.REJECTED) ? true : false;
        return (
            <form className="form-inline timeline-form" onSubmit={onSubmit}>     
            <div className="input-group">
                <span className="input-group-addon"><span className="fa-vertical"></span></span>
                <input type="text" value={value} className="form-control comment" placeholder="We have acted on this incident and it can now be closed, we came to the conclusion that…" onChange={onChange} required={isRequired} maxLength="512"/>
            </div>
            <div className="input-group">
                <button type="submit" className="btn btn-default">Submit</button>
             </div>
            </form>   
        );        
    }
}

CommentForm.propTypes = {
    nextAction: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default translate("translations")(CommentForm);




// WEBPACK FOOTER //
// ./src/incidents/comments/commentForm.js